import React, { useState } from "react";
import { toast } from "react-hot-toast";

const IdentityDetails = ({ data, update, next, prev }) => {

    const [form, setForm] = useState({
        ...(data.identity || {})
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        // setForm({
        //     ...form,
        //     [name]: value
        // });
        setForm(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const removeFile = () => {
        setForm(prev => ({
            ...prev,
            idFile: null
        }));
    };

    const handleFile = (e) => {

        const file = e.target.files[0];

        if (!file) return;

        const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/png",
            "image/jpg"
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.error("Only PDF, JPG, PNG allowed");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            toast.error("File must be under 2MB");
            return;
        }

        // setForm({
        //   ...form,
        //   idFile: file
        // });
        setForm(prev => ({
            ...prev,
            idFile: file
        }));
    };


    const validate = () => {

        if (!form.idType) {
            toast.error("ID type is required");
            return false;
        }

        if (!form.idNumber) {
            toast.error("ID number is required");
            return false;
        }

        if (!form.placeOfBirth) {
            toast.error("Place of birth is required");
            return false;
        }

        // 🔴 Mandatory Upload Validation
        if (!form.idFile) {
            toast.error("ID proof upload is mandatory");
            return false;
        }

        return true;
    };


    const handleNext = () => {
        console.log(!form.idFile);
        const isValid = validate();

        if (!isValid) return;

        update("identity", form);
        next();
    };


    return (

        <div>

            <h3 className="text-xl font-semibold mb-4">
                Identity Details
            </h3>

            <div className="grid grid-cols-2 gap-5">

                {/* ID Type */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        ID Type <span className="text-red-500">*</span>
                    </label>

                    <select
                        name="idType"
                        value={form.idType || ""}
                        onChange={handleChange}
                        className="input w-full"
                    >
                        <option value="">Select ID Type</option>
                        <option>Aadhaar</option>
                        <option>PAN</option>
                        <option>Driving License</option>
                        <option>Passport</option>
                    </select>
                </div>

                {/* ID Number */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        ID Number <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="idNumber"
                        placeholder="Enter ID Number"
                        value={form.idNumber || ""}
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>

                {/* Place of Birth */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Place of Birth <span className="text-red-500">*</span>
                    </label>

                    <input
                        name="placeOfBirth"
                        placeholder="Enter Place of Birth"
                        value={form.placeOfBirth || ""}
                        onChange={handleChange}
                        className="input w-full"
                    />
                </div>

                {/* Upload */}
                <div>
                    <label className="block text-sm font-medium mb-1">
                        Upload ID Proof (Max 2MB)
                        <span className="text-red-500">*</span>
                    </label>

                    <input
                        type="file"
                        onChange={handleFile}
                        className="input w-full"
                    />

                    {form.idFile && (
                        <div className="mt-2 inline-flex items-center bg-blue-50 border border-blue-200 rounded-md px-3 py-1 text-sm relative">

                            <span className="truncate max-w-[180px]">
                                {form.idFile.name}
                            </span>
                            <button
                                type="button"
                                onClick={removeFile}
                                className="ml-2 text-red-500 hover:text-red-700 font-bold"
                            >
                                ✕
                            </button>

                        </div>
                    )}

                </div>

            </div>


            {/* Buttons */}
            <div className="mt-6 flex justify-between">

                <button
                    onClick={prev}
                    className="btn-secondary"
                >
                    Back
                </button>

                <button
                    onClick={handleNext}
                    className="btn-primary"
                >
                    Next
                </button>

            </div>

        </div>

    );
};

export default IdentityDetails;